import * as React from 'react';
// @ts-ignore
import style from './MessageBubble.module.scss?module';
import { SupportChatMessage } from './useSupportChatThread';
import Attachment from './Attachment';

const formatTimestamp = (iso: string): string => {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export default function MessageBubble({ message }: { message: SupportChatMessage }) {
  const isCustomer = message.sender_type === 'customer';
  const wrapperClass = [style.Row, isCustomer ? style.RowCustomer : style.RowStaff].join(' ');
  const bubbleClass = [style.Bubble, isCustomer ? style.BubbleCustomer : style.BubbleStaff].join(' ');

  return (
    <div className={wrapperClass}>
      <div className={bubbleClass}>
        {message.body && <div className={style.Body}>{message.body}</div>}
        {message.attachments.length > 0 && (
          <div className={style.Attachments}>
            {message.attachments.map((attachment) => (
              <Attachment key={attachment.id} attachment={attachment} />
            ))}
          </div>
        )}
        <div className={style.Timestamp}>{formatTimestamp(message.created)}</div>
      </div>
    </div>
  );
}
